// PregnancyConceptionCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { PregnancyConception_EndPoint } from "./ConstantsWomenCalculator";
import { ConceptionTablev2 } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Tanggal Kehamilan dan Perencanaan Kehamilan";
const DESCRIPTION =
  "Kalkulator tanggal kehamilan dan perencanaan kehamilan memperkirakan tanggal pembuahan berdasarkan tanggal perkiraan lahir, tanggal haid terakhir, atau tanggal USG. Tanggal pembuahan adalah hari di mana janin seseorang dibuahi. Kalkulator ini juga memperkirakan rentang hari yang memungkinkan di mana hubungan seksual dapat mengakibatkan pembuahan berdasarkan kemampuan sperma untuk bertahan hidup di dalam tubuh wanita selama 3-5 hari.";
const KEYWORDS = "tanggal kehamilan, perencanaan kehamilan, kalkulator tanggal kehamilan";
const OG_URL = "https://do-calculate.com/calculator/id/pregnancy-conception/";
const apiEndpoint = `${SERVER_URL}/${PregnancyConception_EndPoint}`;
function PregnancyConceptionCalculator() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [periodLength, setPeriodLength] = useState(1);
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculatePregnancyConception = async () => {
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstDayOfLastPeriod,
          cycleLength,
          periodLength,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data["results"]);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <b> Kalkulator Tanggal Kehamilan dan Perencanaan Kehamilan</b>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Kalkulator tanggal kehamilan dan perencanaan kehamilan memperkirakan tanggal pembuahan berdasarkan tanggal perkiraan lahir yang diharapkan, tanggal haid terakhir, atau tanggal USG. Tanggal pembuahan adalah hari di mana janin seseorang dibuahi. Kalkulator ini juga memperkirakan rentang hari yang memungkinkan di mana hubungan seksual dapat mengakibatkan pembuahan berdasarkan kemampuan sperma untuk bertahan hidup di dalam tubuh wanita selama 3-5 hari.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Tanggal Kehamilan dan Perencanaan Kehamilan
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label ms-2">
                      <strong>Hari pertama</strong> haid terakhir
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label ms-2">
                      Rata-rata waktu antar siklus
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">Hari</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculatePregnancyConception}
                  >
                    Hitung{" "}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> Terjadi Kesalahan :</u>
                    </b>{" "}
                    Harap masukkan semua kolom dengan benar.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        Hasil:{" "}
                      </div>
                    </h4>
                    <hr />
                    <ConceptionTablev2 result={result}></ConceptionTablev2>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Deskripsi Kalkulator Tanggal Kehamilan dan Perencanaan Kehamilan :{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <b>Kapan pembuahan terjadi? </b>{" "}
                </u>
                <br />
                Kapan tepatnya kehamilan terjadi? Banyak wanita menanyakan pertanyaan ini ketika mencoba mengetahui hari pasti dimulainya kehamilan mereka. Usia janin, atau usia kehamilan, sering dihitung dari hari pertama haid terakhir ibu. Secara biologis, janin belum dibuahi sampai ovulasi terjadi dan sel telur dibuahi, yang biasanya terjadi setidaknya 10 hari setelah hari pertama haid terakhir ibu.
                <br/>                Karena ada banyak faktor seputar pembuahan, sulit untuk menentukan tanggal pembuahan secara akurat. Kalkulator ini membantu memperkirakan rentang tanggal pembuahan yang sebenarnya dan rentang hari yang memungkinkan di mana hubungan seksual dapat mengakibatkan pembuahan. Ada beberapa metode yang dapat digunakan untuk memperkirakan tanggal pembuahan.
                <br/>                <u>
                  <b>Haid Terakhir</b>{" "}
                </u>
                <br />
                Pembuahan biasanya terjadi antara 11-21 hari setelah hari pertama haid terakhir wanita dengan siklus teratur. Perkiraan tanggal pembuahan didasarkan pada rentang ini, tetapi jarang akurat sepenuhnya karena sulit mengetahui kapan tepatnya ovulasi terjadi. Perkiraan tanggal pembuahan juga bisa lebih sulit bagi wanita dengan siklus tidak teratur, atau bagi mereka yang tidak ingat hari pertama haid terakhir. Dalam kasus seperti ini, salah satu metode paling akurat untuk memperkirakan usia kehamilan adalah menggunakan USG.
                <br/>                <u>
                  <b>Fertilisasi, Pembuahan, dan Kehamilan</b>{" "}
                </u>
                <br />
                Fertilisasi dan pembuahan adalah dua istilah yang sering digunakan secara bergantian. Kalkulator ini menggunakan definisi dokter dan ilmuwan untuk kedua istilah ini. Fertilisasi terjadi ketika sperma dan sel telur bertemu di tuba falopi, membentuk sel telur yang telah dibuahi, dan memulai proses perkembangan janin.
                <br/>                Pembuahan mengacu pada proses kehamilan, yang secara ilmiah mencakup baik fertilisasi maupun implantasi janin ke dinding rahim. Secara medis dan ilmiah, pembuahan memerlukan fertilisasi dan implantasi, dan seorang wanita tidak dianggap hamil sampai keduanya terjadi.
                <br/>                <hr />
                <b>Tanggal peninjauan terakhir : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default PregnancyConceptionCalculator;